<template>
  <v-card id="card-modal-add-transport-company" class="elevation-4">
    <v-card-title class="justify-start py-2 card-modaltitle">
      <div class="pl-4">
        <h3 class="primary--text">
          {{ $t("components.views.trip.offers.client.modal_add_transport_company.title") }}
        </h3>
      </div>
      <v-btn depressed text color="primary" class="cont" @click.stop="$emit('closeForm')">
        <v-icon class="mr-1">fa-solid fa-xmark</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="pb-0">
      <v-container fluid class="pt-0 mt-0">
        <v-row>
          <v-col cols="12">
            <SelectAutocomplete
              v-model="selectedCompanies"
              :data="availableCompanies"
              :init="false"
              multiple
              chips
              deletable-chips
              item-text="businessName"
              item-value="idCompany"
              prepend-icon="fa-solid fa-building"
              :label="$t('components.views.trip.offers.client.modal_add_transport_company.company')"
            />
            <p v-if="error" class="red--text body-2 mt-2 mb-0">
              {{ error }}
            </p>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <v-card-actions class="px-4 py-4">
      <v-spacer />
      <v-btn depressed @click.stop="$emit('closeForm')">
        {{ $t("components.views.trip.offers.client.modal_add_transport_company.cancel") }}
      </v-btn>
      <v-btn color="primary" depressed class="ml-2" @click="confirm()">
        {{ $t("components.views.trip.offers.client.modal_add_transport_company.offer") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    idMonitoringOrder: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      companies: [],
      alreadyPublished: [],
      selectedCompanies: [],
      error: "",
    };
  },
  computed: {
    availableCompanies() {
      const publishedIds = this.alreadyPublished.map((c) => c.idTransporter);
      return this.companies.filter((c) => !publishedIds.includes(c.idCompany));
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    ...mapActions("snackbar", ["showSnack"]),
    ...mapActions("loader", ["showLoader"]),

    async loadData() {
      await Promise.allSettled([
        this.loadTransportCompanies(),
        this.loadAlreadyPublished(),
      ]);
    },

    async loadTransportCompanies() {
      try {
        const response = await this.axios.get("/TransportCompany");
        this.companies = Array.isArray(response.data) ? response.data : [];
      } catch (error) {
        this.companies = [];
      }
    },

    async loadAlreadyPublished() {
      try {
        const response = await this.axios.get(
          `/Offers/RequestListTransportCompany/${this.idMonitoringOrder}`
        );
        this.alreadyPublished = Array.isArray(response.data) ? response.data : [];
      } catch (error) {
        this.alreadyPublished = [];
      }
    },

    async confirm() {
      if (!this.selectedCompanies || this.selectedCompanies.length === 0) {
        this.error = this.$t(
          "components.views.trip.offers.client.modal_add_transport_company.validation_required"
        );
        return;
      }

      this.error = "";
      this.showLoader({ show: true });

      const transportCompanies = this.selectedCompanies.map((idCompany) => {
        const company = this.companies.find((c) => c.idCompany === idCompany);
        return {
          idCompany,
          name: company ? company.businessName : "",
        };
      });

      const params = {
        idMonitoringOrder: this.idMonitoringOrder,
        transportCompanies,
      };

      await this.axios
        .post("/Offers/AddTransportCompany", params)
        .then(() => {
          this.showSnack({
            text: this.$t(
              "components.views.trip.offers.client.modal_add_transport_company.success_message"
            ),
            title: this.$t(
              "components.views.trip.offers.client.modal_add_transport_company.success"
            ),
            name: "success",
          });
          this.$emit("added");
          this.$emit("closeForm");
        })
        .catch((error) => {
          this.showSnack({
            text:
              error.response && error.response.data
                ? error.response.data
                : error.message,
            title: "Error",
            name: "error",
          });
        })
        .finally(() => {
          this.showLoader({ show: false });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
#card-modal-add-transport-company {
  border: 3px solid #0b0045 !important;
}

.card-modaltitle {
  border-bottom: 1px solid #ccc;
}

.cont {
  position: absolute;
  right: 10px;
}
</style>
